import * as React from 'react';

export function BarriosStandard() {
  return (
    <section className="bp-standard">
      <style>{`
        .bp-standard {
          padding: 72px 24px;
          background: #fff;
        }
        .bp-standard-inner {
          max-width: 720px;
          margin: 0 auto;
        }
        .bp-standard h2 {
          font-size: 28px;
          font-weight: 800;
          color: #1a1a1a;
          margin: 0 0 8px;
        }
        .bp-standard .subtitle {
          font-size: 18px;
          color: #666;
          margin: 0 0 32px;
        }
        .bp-checklist {
          list-style: none;
          padding: 0;
          margin: 0 0 28px;
        }
        .bp-checklist li {
          display: flex;
          align-items: center;
          gap: 14px;
          padding: 14px 18px;
          font-size: 16px;
          color: #333;
          font-weight: 500;
          border-radius: 10px;
          margin-bottom: 8px;
          background: #f0fdf0;
        }
        .bp-checklist li i {
          color: #1EAA25;
          font-size: 18px;
          flex-shrink: 0;
        }
        .bp-standard .closing {
          font-size: 16px;
          color: #555;
          font-style: italic;
          margin: 0;
        }
        @media (max-width: 640px) {
          .bp-standard h2 {
            font-size: 24px;
          }
        }
      `}</style>
      <div className="bp-standard-inner">
        <h2>Lo que garantizamos</h2>
        <p className="subtitle">Pensado para familias que valoran lo que comen</p>
        <ul className="bp-checklist">
          <li><i className="fa fa-check-circle" /> Selección del día en Mercado de Abasto</li>
          <li><i className="fa fa-check-circle" /> Entrega programada en tu barrio</li>
          <li><i className="fa fa-check-circle" /> Pedido online desde el celular, las 24 hs</li>
          <li><i className="fa fa-check-circle" /> Variedad de frutas, verduras y más</li>
        </ul>
        <p className="closing">Lo mismo que elegiríamos para nuestra propia mesa.</p>
      </div>
    </section>
  );
}
